import { Divider, Timeline } from 'antd';
import * as React from 'react';

const GetInfo = (
    roomsNumbers,
    howItWasCalculated,
    t,
    currency,
    rewardReferralPerNightRoom,
): JSX.Element => {
    return (
        <>
            <ul style={{ listStyle: 'none', padding: 0 }}>
                {howItWasCalculated?.Limit > 0 ? (
                    <li>
                        {t('howItWasCalculated:limited')}:{' '}
                        <strong>
                            {howItWasCalculated.Limit} {currency} x {roomsNumbers.length}{' '}
                            {roomsNumbers.length > 1
                                ? t('howItWasCalculated:rooms')
                                : t('howItWasCalculated:room')}{' '}
                            = {howItWasCalculated.Limit * roomsNumbers.length} {currency}
                        </strong>
                    </li>
                ) : (
                    ''
                )}
                <li style={{ fontStyle: 'italic', color: 'gray', fontSize: 12 }}>
                    {t('howItWasCalculated:referral-message')}
                </li>
                {howItWasCalculated?.Targets?.length > 0
                    ? howItWasCalculated.Targets?.map((target) => <li>Target: {target.Value}</li>)
                    : ''}
                {rewardReferralPerNightRoom > 0 ? (
                    <>
                        <li>
                            <span>{t('howItWasCalculated:referral')}</span>:{' '}
                            <strong>
                                {rewardReferralPerNightRoom || 'N/A'} {currency}
                            </strong>{' '}
                        </li>
                        <li style={{ fontStyle: 'italic', color: 'gray', fontSize: 12 }}>
                            {howItWasCalculated?.isUnique
                                ? t('howItWasCalculated:referral-message-unique')
                                : t('howItWasCalculated:referral-message-not-unique')}
                        </li>
                    </>
                ) : null}
            </ul>

            {roomsNumbers.map((roomNumber) => {
                return (
                    <>
                        <Divider />
                        <ul style={{ listStyle: 'none', padding: 0 }}>
                            <li>
                                {t('howItWasCalculated:room-number')}: {roomNumber}
                            </li>
                            <li>
                                {t('howItWasCalculated:room-type')}:{' '}
                                {
                                    howItWasCalculated?.ResumeByDay?.filter(
                                        (rby) => rby.RoomNumber == roomNumber,
                                    )[0].RoomName
                                }
                            </li>
                            <li>
                                {t('howItWasCalculated:regime-name')}:{' '}
                                {
                                    howItWasCalculated?.ResumeByDay?.filter(
                                        (rby) => rby.RoomNumber == roomNumber,
                                    )[0].RegimeName
                                }
                            </li>
                        </ul>
                        <Timeline>
                            {howItWasCalculated?.ResumeByDay?.filter(
                                (rby) => rby.RoomNumber == roomNumber,
                            ).map((resumeByDay) => {
                                return (
                                    <Timeline.Item>
                                        {resumeByDay.Day}
                                        <ul>
                                            <li>
                                                <span style={{ textDecoration: 'underline' }}>
                                                    {t('howItWasCalculated:group-name')}
                                                </span>{' '}
                                                <br /> <strong>{resumeByDay.GroupName}</strong>
                                                <ul>
                                                    <li>
                                                        {t('howItWasCalculated:period-name')}:{' '}
                                                        {resumeByDay.PeriodName}
                                                    </li>
                                                    <li>
                                                        {t('howItWasCalculated:amount')}:{' '}
                                                        <strong>
                                                            {resumeByDay.Amount} {currency}
                                                        </strong>
                                                    </li>
                                                </ul>
                                            </li>

                                            <li>
                                                {' '}
                                                <span style={{ textDecoration: 'underline' }}>
                                                    {t('howItWasCalculated:advanced-group-name')}
                                                </span>{' '}
                                                <br />
                                                <strong>
                                                    {' '}
                                                    {resumeByDay.AdvancedGroup || 'N/A'}
                                                </strong>
                                                {resumeByDay.Increment > 0 ? (
                                                    <ul>
                                                        <li>
                                                            {t('howItWasCalculated:increment')}:{' '}
                                                            <strong>
                                                                {resumeByDay.Increment} {currency}
                                                            </strong>
                                                        </li>
                                                    </ul>
                                                ) : null}
                                            </li>

                                            <li>
                                                <span style={{ textDecoration: 'underline' }}>
                                                    {t('howItWasCalculated:academy-group-name')}
                                                </span>{' '}
                                                <br />{' '}
                                                <strong>{resumeByDay.AcademyGroup || 'N/A'}</strong>
                                                {resumeByDay.AcademyIncrement > 0 ? (
                                                    <ul>
                                                        <li>
                                                            {t('howItWasCalculated:increment')}:{' '}
                                                            <strong>
                                                                {resumeByDay.AcademyIncrement}{' '}
                                                                {currency}
                                                            </strong>
                                                        </li>
                                                    </ul>
                                                ) : null}
                                            </li>

                                            {resumeByDay.FirstReward > 0 ? (
                                                <li>
                                                    <span style={{ textDecoration: 'underline' }}>
                                                        {t('howItWasCalculated:first-reward')}
                                                    </span>
                                                    :{' '}
                                                    <strong>
                                                        {resumeByDay.FirstReward || 'N/A'}{' '}
                                                        {currency}
                                                    </strong>{' '}
                                                </li>
                                            ) : null}
                                        </ul>
                                    </Timeline.Item>
                                );
                            })}
                        </Timeline>
                    </>
                );
            })}
        </>
    );
};

export default GetInfo;
